import { Stack } from '@chakra-ui/react';
import { Breadcrumbs, Button, Text } from '@diamond/shared/ui';
import AddIcon from '@mui/icons-material/Add';

interface BannerHeaderProps {
  links: { title: string; link: string }[];
  onAdd: () => void;
}

export function BannerHeader({ links, onAdd }: BannerHeaderProps) {
  return (
    <>
      <div style={{ paddingBottom: 16 }}>
        <Breadcrumbs links={links} useRouterDom />
      </div>
      <div style={{ paddingTop: 16 }}>
        <Stack spacing={8} direction="row" justifyContent="space-between">
          <Text fontSize="2xl" fontWeight="bold">
            Banner Management
          </Text>
          <Button
            leftIcon={<AddIcon />}
            bg="blue"
            color="white"
            variant="solid"
            _hover={{ bg: 'navy' }}
            onClick={onAdd}
          >
            Tambah Banner
          </Button>
        </Stack>
      </div>
    </>
  );
}
